export default __webpack_public_path__ + "static/media/moneris.68d898a5.png";